<template>
  <header class="header">
    <div class="exitblock" @click="$root.requestModal = 2"></div>
    <div class='container'>
      <div class="header__warpper">
        <router-link to="/" class="header__logo">
          <img class="header-desktop" src="/static/img/header/logo-bez-ur.svg" alt="logo" />
        </router-link>
        <div class="header__burger">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="menu">
          <ul class="menu__list">
            <li><router-link to="/how-it-works" class="menu__link">Как это работает</router-link></li>
            <li><router-link to="/win" class="menu__link">Как самому выиграть дело в суде</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'header',
  data () {
    return {
      url: null
    }
  },
  created () {
    this.url = this.$router.currentRoute.path
  },
  watch: {
    $route (to, from) {
      this.url = to.path
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/include/header.vue